<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{Translate('Select equipment to create new inspection')}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>

  <div class="ttmodal__body" *ngIf="isloading">
    <div style="align-items: center; display: block; margin-left:40%;">
      <mat-spinner></mat-spinner>
    </div>

  </div>


  <div class="ttmodal__body" *ngIf="!isloading">
    <div *ngIf="isInspector">
        <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
              <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
                {{ customer.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite" placeholder="{{Translate('Select Job Site')}}">
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="setup-form-full-width">
            <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
              <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                {{ equipment.Serial+ ' : ' + equipment.Unit }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="noComponents">
            {{Translate('There is no Components attached to this equipment')}}
        </div>

        <div *ngIf="IsRopeShovel">
          {{Translate('Rope Shovel Inspections cannot be set up here, Please setup inspection on Mobile App')}}
      </div>
          <div class="ttmodal__footer">
            <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
            <button mat-raised-button color="warn" [disabled]="!equipmentSelected || noComponents || IsRopeShovel" (click)="selectEquipment()"><span class="material-icons button__icon">check</span><span
                class="button__text">{{Translate('Start Inspection')}}</span></button>
          </div>
    </div>
    <div *ngIf="!isInspector">
        {{Translate('Please check your user permissions, Only inspector or super user can create inspections')}}
        <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
    </div>

   
  </div>

</div>
